// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/modern/" + {"25":"slim-select","508":"imask","610":"ajax-form-sender","835":"object-fit-images","897":"lightgallery","928":"simplebar"}[chunkId] + "." + {"25":"3479553c","508":"d81f60f7","610":"70721be0","835":"01daa397","897":"34713e49","928":"8f3f5c1e"}[chunkId] + ".js";
};